import { render, staticRenderFns } from "./MonitoraggioPressioneEdit.vue?vue&type=template&id=0dd043c5&scoped=true"
import script from "./MonitoraggioPressioneEdit.vue?vue&type=script&lang=js"
export * from "./MonitoraggioPressioneEdit.vue?vue&type=script&lang=js"
import style0 from "./MonitoraggioPressioneEdit.vue?vue&type=style&index=0&id=0dd043c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd043c5",
  null
  
)

export default component.exports